import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosCupom from './FiltrosAdicionadosCupom'
import FiltroCupom from './FiltroCupom'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroCupom = () => (
  <Filtro PainelFiltro={FiltroCupom}/>
);

const PainelFiltrosCupom = () => (
  <PainelFiltragem
    Filtro={PainelFiltroCupom}
    FiltrosAdicionados={FiltrosAdicionadosCupom}/>
)

export default PainelFiltrosCupom
